{
  "incidents": "Incidents",
  "incident": "Incident",
  "searchByName": "Search by name",
  "copyId": "Copy ID",
  "incidentIdCopied": "Incident id copied.",
  "copyLeLink": "Copy LE link",
  "resolvedAt": "Resolved At",
  "ongoing": "Ongoing",
  "past": "Past",
  "leWebappLinkCopied": "Le WebApp link copied."
}
